import { axiosGetHandler, axiosPostHandler } from '../config';

// 获取邀请信息
export function getInviteInfo(args) {
  let url = '/game/invite_friend_data/';
  return axiosGetHandler(url, args);
}

// 获取邀请信息(分享页)
export function getShareInviteInfo(args) {
  let url = '/game/invite_friend_web_share_data/';
  return axiosGetHandler(url, args);
}
